import { render, staticRenderFns } from "./market.vue?vue&type=template&id=62a82752&scoped=true&"
import script from "./market.vue?vue&type=script&lang=js&"
export * from "./market.vue?vue&type=script&lang=js&"
import style0 from "./market.vue?vue&type=style&index=0&id=62a82752&prod&lang=css&"
import style1 from "./market.vue?vue&type=style&index=1&id=62a82752&prod&lang=scss&"
import style2 from "./market.vue?vue&type=style&index=2&id=62a82752&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a82752",
  null
  
)

export default component.exports